import { components } from '@features/shared/api/user';

export function findUserTicket(
  tickets: components['schemas']['UserTicketDto'][] | undefined | null,
  clibId: string,
  ticket: string,
) {
  return tickets?.find((t) => t.clubId === clibId && t.ticket === ticket);
}
